import { NOTIFY_ERROR } from 'src/vuex/modules/snackbar/types'
import { getAccountStatements, getAccounts } from '../apiCalls'
import * as types from './types'

export default {
  [types.GET_ACCOUNT_STATEMENTS]: async ({ commit, getters }) => {
    commit(types.SET_IS_ACCOUNT_STATEMENTS_LOADING, true)

    try {
      const params = getters[types.PARAMS_TO_SEND]
      const { accountId, ...restParams } = params
      const accountStatements = await getAccountStatements(
        accountId,
        restParams
      )

      commit(types.SET_ACCOUNT_STATEMENTS, accountStatements.results)
      commit(types.SET_TOTAL_ITEMS, accountStatements.summary.total_items)
    } catch (err) {
      console.error(err)

      commit(types.SET_ACCOUNT_STATEMENTS, [])
      commit(types.SET_TOTAL_ITEMS, 0)
    } finally {
      commit(types.SET_IS_ACCOUNT_STATEMENTS_LOADING, false)
    }
  },
  [types.CHANGE_FILTERS]({ commit }, filterValue) {
    commit(types.SET_FILTERS, filterValue)
  },
  [types.CHANGE_PAGINATION]({ commit }, pagination) {
    commit(types.SET_ACCOUNT_STATEMENTS, [])
    commit(types.SET_PAGINATION, pagination)
  },
  [types.RESET_PAGINATION]({ state, dispatch }) {
    dispatch(types.CHANGE_PAGINATION, {
      ...state.pagination,
      page: 1
    })
  },
  [types.GET_ACCOUNTS]: async ({ commit, getters, dispatch }) => {
    commit(types.CLEAR_ACCOUNTS)
    commit(types.SET_IS_ACCOUNTS_LOADING, true)

    try {
      const companyId = getters[types.COMPANY_ID]
      const accounts = await getAccounts(companyId).then((response) =>
        response.results.map((account) => ({
          key: account.id,
          value: account.name
        }))
      )

      commit(types.SET_ACCOUNTS, accounts)
    } catch (err) {
      console.error(err)
      dispatch(NOTIFY_ERROR, { message: err.response.data })
    } finally {
      commit(types.SET_IS_ACCOUNTS_LOADING, false)
    }
  },
  [types.RESET_STATE]({ commit }) {
    commit(types.SET_STATE)
  }
}
